<template>
  <div>
    <button class="d-none" data-toggle="modal" data-target="#TournamentEditGame"
      ref="openModalTournamentEditGame"></button>
    <div class="modal fade" tabindex="-1" role="dialog" id="TournamentEditGame">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
             <div>
              <h6 class="modal-title m-0">Edit Game</h6>
              <div class="products-list-shim p-0" v-if="showLoader == 1">
                <content-placeholders :rounded="true">
                  <content-placeholders-text :lines="1"/>
                </content-placeholders>
              </div>
              <span v-else class="text-capitalize">{{tournamentData?.tournamentName}}</span>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
              ref="closeModalTournamentEditGame">
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body">
            <div class="row no-gutters">
              <div class="col-12 col-md-3 pr-md-2">
                <div class="form-group">
                  <select class="form-control" id="gameType" v-model="game_type" :class="{
                    filled: game_type,
                    'is-invalid': $v.game_type.$error,
                    'is-valid': !$v.game_type.$invalid,
                  }">
                    <option value="1">Pool</option>
                    <option value="2">Bracket</option>
                  </select>
                  <span v-if="!$v.game_type.required" class="invalid-tooltip">
                    Game type is required
                  </span>
                  <span class="placeholder">Game Type</span>
                </div>
              </div>
              <div class="col-12 col-md-9">
                <div class="form-group">
                  <input id="game-name-edit" class="form-control" v-model="name" spellcheck="false" autocomplete="off" trim
                    type="text" required :class="{
                      filled: name,
                      'is-invalid': $v.name.$error,
                      'is-valid': !$v.name.$invalid,
                  }"/>
                  <span v-if="!$v.name.required" class="invalid-tooltip">
                    Game name is required
                  </span>
                  <span class="placeholder">Game Name</span>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
               <div class="col-sm-12 col-md-6">
                <div class="form-group">
                  <select class="form-control" id="teamOne" v-model="teamOne"
                    @change="filterTeam" :disabled="teamLoader"
                    :class="{
                      filled: teamOne,
                        'is-invalid': shouldValidateTeams && $v.teamOne.$error,
                        'is-valid': shouldValidateTeams && !$v.teamOne.$invalid
                      }">
                    <option v-for="option in tournamentTeams"
                      :value="option.team.id" :key="option.id" >
                      {{ option.team.team_name }}
                    </option>
                  </select>
                  <span class="placeholder">Team 1</span>
                  <div class="invalid-tooltip" v-if="shouldValidateTeams && !$v.teamOne.required">
                    Team 1 is required
                  </div>
                  <div class="shop-products-img-loader" v-if="teamLoader">
                    <div class="lds-dual-ring-media"></div>
                  </div>
                </div>
              </div>

              <div class="col-sm-12 col-md-6 pl-md-2">
                <div class="form-group">
                  <select class="form-control" id="teamTwo"
                    v-model="teamTwo" :disabled="teamLoader"
                    :class="{
                      filled: teamTwo,
                      'is-invalid': shouldValidateTeams && $v.teamTwo.$error,
                      'is-valid': shouldValidateTeams && !$v.teamTwo.$invalid
                    }">
                    <option
                      v-for="option in remainingTeams"
                      :value="option.team.id"
                      :key="option.id"
                    >
                      {{ option.team.team_name }}
                    </option>
                  </select>
                  <span class="placeholder">Team 2</span>
                  <div class="invalid-tooltip" v-if="shouldValidateTeams && !$v.teamTwo.required">
                    Team 2 is required
                  </div>
                  <div class="shop-products-img-loader" v-if="teamLoader">
                    <div class="lds-dual-ring-media"></div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="form-group">
                  <select class="form-control" id="umpire" :class="{ filled: umpire }" v-model="umpire"
                    :disabled="isLoadingUmpire">
                    <!-- Only display umpires if they are loaded and available -->
                    <option v-for="option in tournamentUmpire" :value="option.umpire.id" :key="option.umpire.id">
                      {{ option.umpire.name }}
                    </option>
                  </select>
                  <span class="placeholder">Umpire</span>

                  <!-- Loader for umpire loading -->
                  <div class="shop-products-img-loader" v-if="isLoadingUmpire">
                    <div class="lds-dual-ring-media"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-sm-12 col-md-6">
                <div class="form-group" :class="{ filled: startDate }">
                  <date-picker :open="open" @close="open = false" :editable="false" :clearable="false"
                    @click.native="open = true" v-model="startDate" valueType="format" format="MMM DD, YYYY"
                    @change="checkdate"  :class="{
                    'is-invalid': $v.startDate.$error,
                    'is-valid': !$v.startDate.$invalid,
                  }">
                    <i slot="icon-calendar" class="cursor-pointer">
                      <img src="../../../assets/Svg/calendar.svg" />
                    </i>
                  </date-picker>
                  <span v-if="!$v.startDate.required" class="invalid-tooltip">
                    Start date is required
                  </span>
                  <span class="placeholder">Start Date</span>
                </div>
              </div>
          
              <div class="col-sm-12 col-md-6 pl-md-2">
                <div class="form-group" :class="{ filled: startTime }">
                  <div class="input-group time" id="startTimeCheck" data-target-input="nearest">
                    <vue-timepicker id="startTime" class="time-input" format="hh:mm A"
                      required="required" v-model="startTime" v-on:change="checkTime"
                      hide-clear-button @open="dropdownState = 'opened'" @close="dropdownState = 'closed'" :class="{
                      'is-invalid': $v.startTime.$error,
                      'is-valid': !$v.startTime.$invalid,
                    }">
                      <template v-slot:icon>
                        <img src="../../../assets/Svg/clock.svg" />
                      </template>
                    </vue-timepicker>
                    <span v-if="!$v.startTime.required" class="invalid-tooltip">
                      Start time is required
                    </span>
                  </div>
                  <span class="placeholder">Start Time</span>
                </div>
              </div>
            </div>

            <div class="row no-gutters mb-3">
              <div class="col-sm-12 col-md-6 my-3 my-md-0">
                <div class="position-relative">
                  <!-- <button @click="openPark" class="button-overlay"></button> -->
                  <multiselect ref="multiselectParkName" v-model="partName" id="ajaxsingle" label="park_name"
                    track-by="id" placeholder="Park" open-direction="top" :options="parkNameOptions"
                    :searchable="true" :loading="isLoading" :internal-search="false" :clear-on-select="false"
                    :close-on-select="true" :options-limit="300" :show-no-results="false" :hide-selected="true"
                    @search-change="getGamePark" @input="checkParkField" @select="dispatchAction"
                    @open="isOpenPark = true" :class="{
                    'is-invalid': $v.partName.$error,
                    'is-valid': !$v.partName.$invalid
                  }">
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">&nbsp;<span> {{ option.park_name }}</span><span class="custom__remove"
                          v-on:click="remove(option)">❌</span></span>
                    </template>
                    <template slot="clear" slot-scope="props">
                      <div class="multiselect__clear" v-if="parkNameOptions.length"
                        @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">Oops! No Park found. Consider changing the search query.</span>
                    <span slot="noOptions">No Park Found</span>
                    <template #caret>
                      <span class="custom-arrow">
                        <img src="../../../assets/Svg/arrow-down.svg" alt="add" />
                      </span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
                        <span> {{ option.park_name }}</span>
                      </div>
                    </template>
                  </multiselect>
                  <span v-if="$v.partName.$error" class="invalid-tooltip">
                    Park is required
                  </span>
                </div>
              </div>

              <div class="col-sm-12 col-md-6 pl-md-2">
                <div class="">
                  <!-- <button @click="openField" class="button-overlay"></button> -->
                  <multiselect ref="multiselectParkField" v-model="parkField" id="ajaxsingle" label="field_name"
                    track-by="id" placeholder="Field" open-direction="top" :options="fieldNameOptions"
                    :searchable="true" :loading="isLoadingField" :internal-search="false" :clear-on-select="false"
                    :close-on-select="true" :options-limit="300" :show-no-results="false" :hide-selected="true"
                    @search-change="getParkField" @select="dispatchfieldAction"
                    @open="isOpenField = true">
                    <template slot="tag" slot-scope="{ option, remove }">
                      <span class="custom__tag">&nbsp;<span> {{ option.field_name }}</span><span class="custom__remove"
                          v-on:click="remove(option)">❌</span></span>
                    </template>
                    <span slot="noResult">Oops! No Field found. Consider changing the search query.</span>
                    <span slot="noOptions">No Field Found</span>
                    <template #caret>
                      <span class="custom-arrow">
                        <img src="../../../assets/Svg/arrow-down.svg" alt="add" />
                      </span>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                      <div class="option__desc">
                        <span> {{ option.field_name }}</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>
            </div>

            <div class="form-group">
              <input type="text" class="form-control" id="note" v-model="note" required />
              <span class="placeholder">Game Notes</span>
            </div>

            <a class="d-none" data-toggle="modal" data-target="#ModalPARK" ref="callPark" @click="closeMain">
              Add New Park
            </a>
            <a class="d-none" data-toggle="modal" data-target="#ModalField" ref="callField" @click="newField">
              Add New Field
            </a>

            <a class="d-none" data-toggle="modal" data-target="#gameBulkReplaceModal" id="openBulkReplaceModal"
              href="#"></a>
          </div>

          <div class="event-btns-wrapper justify-content-end">
            <button type="button" class="btn btn-primary" block
              @click="updateGame(0)" :disabled="isLoadingArray[0]">
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <div v-else><img class="mr-1" src="../../../assets/Svg/save.svg" alt="save" />Update</div>
            </button>
          </div>
        </div>
      </div>
    </div>
    <NewPark />
    <NewField />
  </div>
</template>
<script>
import axios from "axios";
import VueTimepicker from "vue2-timepicker";
import Multiselect from "vue-multiselect";
import NewPark from "../../Teams/Games/AddPark";
import NewField from "../../Teams/Games/AddField";
import {
  required,
} from "vuelidate/lib/validators";
export default {
  name: "TournamentEditGameModal",
  components: {
    VueTimepicker,
    Multiselect,
    NewPark,
    NewField,
  },
  data() {
    return {
      // variable for the dropdown state
      dropdownState: 'closed',
      name: "",
      teamOne: "",
      umpire: "",
      teamTwo: "",
      open: false,
      isLoadingArray: [],
      singleGame: [],
      selectedParkId: "",
      userName: localStorage.getItem("userName"),
      isDisabled: true,
      partName: "",
      parkField: "",
      exactStartTime: "10:00 AM",
      exactStartDate: "",
      startDate: "",
      startTime: "10:00 AM",
      note: "",
      game_type: "",
      startDateError: "",
      exactDateformat: "",
      timeError: "",
      parkNameOptions: [],
      fieldNameOptions: [],
      tournamentUmpire: [],
      tournamentTeams: [],
      teamSelect: [],
      teamLoader: true,
      isLoading: false,
      isLoadingField: false,
      isLoadingUmpire: true,
      tabsTo: 0,
      changePark: 0,
      changeField: 0,
      showLoader: 0,
      parkId: "",
      isOpenPark: false,
      isOpenField: false,
    };
  },
   validations() {
  const shouldValidateTeams = Number(this.game_type) === 1;

  return {
    name: { required },
    game_type: { required },
    startDate: { required },
    startTime: { required },
    partName: { required },
    teamOne: {
      required: shouldValidateTeams ? required : () => true
    },
    teamTwo: {
      required: shouldValidateTeams ? required : () => true
    }
  };
},
  props: {
    tournamentData: {
      typeof: Object,
      default: () => ({})
    }
  },
  watch: {
    tournamentData: {
      immediate: true, // Trigger the watcher immediately on component mount
      handler(newVal) {
        console.log('Tournament Data updated:', newVal);
      },
    },
  },
  computed: {
    shouldValidateTeams() {
      return Number(this.game_type) === 1;
    },
    // remainingTeams() {
    //   return this.tournamentTeams.filter(
    //     team => team.team.id !== this.teamOne
    //   );
    // }
    remainingTeams: {
      get() {
        return this.tournamentTeams.filter(
          team => team.team.id !== this.teamOne);
      },
      set(value) {
        this.teamSelect = value;
      }
    }
  },
  methods: {
     async getTournamentName() {
      const tournamentGuid = this.singleGame?.tournament?.guid;
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/getSingleTournament`,
          {tournament_guid: tournamentGuid}
        );

        if (response.data.statusCode === 200) {
            this.tournamentData = response.data.data;
            // this.$root.$emit("tournmentSingleGameForTab", this.tournamentData )
            // this.$root.$emit("tournmentSingleGameForGame", this.tournamentData )
            this.showLoader = 0;
        } else {
          this.errorMessage = response.data.message || "Unknown error occurred";
          this.showLoader = 0;
        }
      } catch (error) {
        this.errorMessage = "Failed to fetch data";
        this.showLoader = 0;
      } finally {
        this.showLoader = 0;
      }
  },
    dataReset() {
      if (this.tabsTo == 0) {
        this.isDisabled = true;
        this.name = "";
        this.teamOne = "";
        this.umpire = "";
        this.teamTwo = "";
        this.partName = "";
        this.parkField = "";
        this.exactStartTime = "10:00 AM";
        this.exactStartDate = "";
        this.startDate = "";
        this.startTime = "10:00 AM";
        this.note = "";
        this.game_type = "";
        this.startDateError = "";
        this.exactDateformat = "";
        this.timeError = "";
        this.parkNameOptions = [];
        this.fieldNameOptions = [];
      } else {
        // this.partName = "";
        this.parkField = "";
      }
    },
    filterTeam() {
      this.remainingTeams = this.tournamentTeams.filter(
        team => team.team.id !== this.teamOne
      );
    },
    handleClickStart(evt) {
      if (evt.target.tagName !== "INPUT") {
        this.open = true;
      }
    },
    openPark() {
      this.getGamePark();
      setTimeout(() => {
        this.$refs.multiselectParkName.activate();
      }, 1000);
    },

    openField() {
      this.getParkField();
      setTimeout(() => {
        this.$refs.multiselectParkField.activate();
      }, 1000);
    },

    checkdate: function () {
      const month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "July",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      // // Start Date
      // if (this.startDate.length == 10) {
      //   const startDateArray = this.startDate.split("-");
      //   var startMonth = startDateArray[1];
      //   var startDay = startDateArray[2];
      //   var startYear = startDateArray[0];

      //   var varDate = startMonth + "-" + startDay + "-" + startYear; //dd-mm-YYYY
      //   var startDateConvert = new Date(varDate);
      //   this.exactStartDateformat = startDateConvert;
      //   this.exactStartDate = month[startMonth - 1] + " " + startDay + ", ";
      // }

      let startDateConvert;

      // Convert Start Date
      if (this.startDate && this.startDate.length === 12) {  // Format: "Mar 21, 2025"
        const startDateArray = this.startDate.split(" ");
        let startMonth = month.indexOf(startDateArray[0]) + 1; // Convert month to number
        startMonth = startMonth < 10 ? `0${startMonth}` : startMonth; // Add leading zero
        const startDay = startDateArray[1].replace(",", ""); // Remove comma
        const startYear = startDateArray[2];

        const formattedStartDate = `${startMonth}-${startDay}-${startYear}`;
        startDateConvert = new Date(formattedStartDate);
        this.exactStartDateformat = startDateConvert;
        this.exactStartDate = `${month[startMonth - 1]} ${startDay}, ${startYear}`;
      }

      this.checkTimeDate();
    },
    dispatchAction(actionName) {
      this.parkField = "";
      this.fieldNameOptions = [];
      switch (actionName.park_name) {
        case "Add Park":
          var tabs = 0;
          this.$root.$emit("AddParkInitiate", tabs);
          var elem = this.$refs.callPark;
          elem.click();
          break;
        default:
          // Assume that the actionName contains the selected park's ID
          this.selectedParkId = actionName.id;
          break;
      }
    },
    closeMain() {
      this.$root.$emit("AddPark");
      var elem = this.$refs.closeModalTournamentEditGame;
      elem.click();
    },
    newField() {
      this.$root.$emit("AddField");
      var elem = this.$refs.closeModalTournamentEditGame;
      elem.click();
    },
    getGamePark() {
      this.isLoading = true;

      // Use this.tournamentData.event.id if it exists, otherwise use this.singleGame.event_id
      const eventId = this.tournamentData?.event?.id || this.singleGame?.event_id;

      axios
        .get(
          `${process.env.VUE_APP_API_URL}associationEvent/getEventPlayingFacility?event_id=${eventId}`
        )
        .then((response) => {
          this.parkNameOptions = response.data.data.parkDetails;
        })
        .catch((error) => {
          console.error("Error fetching park details:", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getParkField(searchQuery) {
      this.isLoadingField = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}getParkField?park_id=${this.parkId
          }&search=${searchQuery ? searchQuery : ""}`,
          this.details,
          {}
        )
        .then((response) => {
          this.fieldNameOptions = response.data.data.fields;
          this.isLoadingField = false;
        });
    },
    getTournamentUmpire() {
      if (this.singleGame) {
        this.isLoadingUmpire = true;
        axios
          .get(
            `${process.env.VUE_APP_API_URL}associationEvent/getUmpiresForDropDown?event_id=${this.singleGame.event_id}`,
            {}
          )
          .then((response) => {
            this.tournamentUmpire = response.data.data.umpires;
            this.isLoadingUmpire = false;
          })
          .catch((error) => {
            console.error("Error fetching tournament umpires:", error);
            this.isLoadingUmpire = false;
          });
      }
    },
    getTournamentUmpireFromScoring() {
      if (this.singleGame) {
        this.isLoadingUmpire = true;
        axios
          .get(
            `${process.env.VUE_APP_API_URL}associationEvent/getUmpiresForDropDown?event_id=${this.singleGame.event.id}`,
            {}
          )
          .then((response) => {
            this.tournamentUmpire = response.data.data.umpires;
            this.isLoadingUmpire = false;
          })
          .catch((error) => {
            console.error("Error fetching tournament umpires:", error);
            this.isLoadingUmpire = false;
          });
      }
    },
    getTournamentTeams() {
      const tournamentGuid = this.singleGame?.tournament?.guid;
      this.teamLoader = true;
      // Create a FormData object
      const formData = new FormData();
      formData.append('tournament_guid', tournamentGuid);

      axios
        .post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentTeamsForDropDown`,
          formData, {})
        .then((response) => {
          this.tournamentTeams = response.data.data;
          this.teamLoader = false;
        });
    },
    getTournamentTeamsFromScoring() {
      const tournamentGuid = this.singleGame?.tournament?.guid;
      const formData = new FormData();
      formData.append('tournament_guid', tournamentGuid);

      axios
        .post(
          `${process.env.VUE_APP_API_URL}tournaments/teams/getTournamentTeamsForDropDown`,
          formData, {})
        .then((response) => {
          this.tournamentTeams = response.data.data;
          this.teamLoader = false;
        });
    },

    checkParkField: function () {
      this.parkId = this.partName.id;
      this.getParkField();
    },
    dispatchfieldAction(actionName) {
      switch (actionName.field_name) {
        case "Add field":
          var tabs = 3;
          this.$root.$emit("AddFieldInitiate", {
            tabs,
            park_id: this.partName.id,
          });
          var elem = this.$refs.callField;
          elem.click();
          break;
      }
    },
    checkTime: function () {
      if (this.startTime != "") {
        var timeSplit = this.startTime.split(":"),
          hours,
          minutes;
        hours = timeSplit[0];
        minutes = timeSplit[1];
        if (hours > 12) {
          hours -= 12;
        } else if (hours < 12) {
          if (hours == 0) {
            hours = 12;
          }
        }
        this.exactStartTime = hours + ":" + minutes;
        this.timeError = "";
        this.isDisabledGame = false;
      }

      this.checkTimeDate();
    },
    closePark() {
      this.tabsTo = 0;
      var start_time = document.getElementById("startTime");
      if (start_time.value != "") {
        start_time.value = "";
      }
    },
    checkTimeDate() {
      this.startDateError = this.exactStartDate != "" ? "" : "on";
      if (this.exactStartTime != "" && this.exactStartDate != "") {
        this.exactDateformat = this.exactStartDate + " " + this.exactStartTime;
      }
    },

    async updateGame(index) {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;

      if (this.$v.$invalid) {
        return
      }
      // Start the loader and disable the game controls
      this.showLoaderGame = true;
      this.isDisabledGame = true;
      this.$set(this.isLoadingArray, index, true);

      // Prepare the form data for the POST request
      var formData = new FormData();
      formData.append("game_name", this.name ? this.name : "");
      formData.append("team_1_id", this.teamOne ? this.teamOne : "");
      formData.append("event_id", (this.tournamentData && this.tournamentData.event) ? this.tournamentData.event.id : this.singleGame.event.id);
      formData.append("team_2_id", this.teamTwo ? this.teamTwo : "");
      formData.append("start_date", this.formatDateForDB(this.startDate));
      formData.append("start_time", this.startTime);
      formData.append("park_id", this.partName.id);
      formData.append("game_type", this.game_type ? this.game_type : "");
      formData.append("comments", this.note ? this.note : "");
      if (this.parkField && this.parkField.id != "") {
        formData.append("field_id", this.parkField.id ? this.parkField.id : null);
      }
      formData.append("game_id", this.singleGame.id);
      if(this.umpire === 0){
        formData.append("umpire_id", "");
      } else {
        formData.append("umpire_id", this.umpire ? this.umpire : "");
      }

      try {
        // Send the POST request to the server
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}tournaments/editTournamentGame`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.data.statusCode === 404 ) {
          this.$refs.closeModalTournamentEditGame.click();
          this.$set(this.isLoadingArray, index, false);
          this.$alert(response.data.message, 'Error');
          this.$router.push({ name: "Teams" });
        } else if(response.data.statusCode === 403) {
          this.$alert(response.data.message, 'Error');
          this.$root.$emit("RefreshTournamentGames");
          this.tabsTo = 0;
          if (this.$refs.closeModalTournamentEditGame) {
            this.$refs.closeModalTournamentEditGame.click();
          }
        } else {
          this.$root.$emit("RefreshTournamentGames");
          this.tabsTo = 0;
          if (this.$refs.closeModalTournamentEditGame) {
            this.$refs.closeModalTournamentEditGame.click();
          }
        }
      } catch (error) {
        console.error("Error updating game: ", error);
      } finally {
        this.showLoaderGame = false;
        this.isDisabledGame = false;
        this.$set(this.isLoadingArray, index, false);

      }
    },
    


    formatTime(timeString) {
      const [hours, minutes] = timeString.split(":");
      let formattedHours = parseInt(hours, 10) % 12 || 12; // Convert hours to 12-hour format
      const meridian = parseInt(hours, 10) >= 12 ? "PM" : "AM"; // Determine meridian (AM or PM)
      formattedHours = formattedHours < 10 ? "0" + formattedHours : formattedHours; // Add leading zero if necessary
      return `${formattedHours}:${minutes} ${meridian}`;
    },
    checkUpdate() {
      this.$v.$reset();
      this.isDisabledGame = true;
      this.showLoaderGame = 0;
      this.startTime = this.singleGame.start_time;
      this.name = this.singleGame.game_name;
      this.teamOne = this.singleGame.team_1_id;
      this.teamTwo = this.singleGame.team_2_id;
      if(this.singleGame.umpire_id){
        this.umpire = this.singleGame.umpire_id 
      } else {
        this.umpire = 0;
      }
      this.game_type = this.singleGame.game_type;
      this.partName = this.singleGame.park;
      this.parkField = this.singleGame.field;
      this.parkId = this.singleGame.park_id;
      this.previousName = this.singleGame;
      this.exactStartTime = "10:00 AM";
      this.exactStartDate = "";
      // this.startDate = this.singleGame.start_date;
      this.note = this.singleGame.comments;
      this.startDateError = "";
      this.exactDateformat = "";
      this.timeError = "";
      this.parkNameOptions = [];
      this.country = this.singleGame.opponent_country;
      this.region = this.singleGame.opponent_state;
      this.opponentCity = this.singleGame.opponent_city;
      this.initializeDate();
      this.getTournamentUmpire();
      this.getTournamentTeams();
      this.checkdate();
      this.checkTime();
      this.getGamePark();

    },
    checkUpdate1() {
      this.$v.$reset();
      this.isDisabledGame = true;
      this.showLoaderGame = 0;
      this.startTime = this.singleGame.start_time;
      this.name = this.singleGame.game_name;
      this.teamOne = this.singleGame.team_1_id;
      this.teamTwo = this.singleGame.team_2_id;
      if(this.singleGame.umpire_id){
        this.umpire = this.singleGame.umpire_id 
      } else {
        this.umpire = 0;
      }
      this.game_type = this.singleGame.game_type;
      this.partName = this.singleGame.park;
      this.parkField = this.singleGame.field;
      this.parkId = this.singleGame.park_id;
      this.previousName = this.singleGame;
      this.exactStartTime = "10:00 AM";
      this.exactStartDate = "";
      // this.startDate = this.singleGame.start_date;
      this.note = this.singleGame.comments;
      this.startDateError = "";
      this.exactDateformat = "";
      this.timeError = "";
      this.parkNameOptions = [];
      this.country = this.singleGame.opponent_country;
      this.region = this.singleGame.opponent_state;
      this.opponentCity = this.singleGame.opponent_city;
      this.initializeDate();
      this.getTournamentUmpireFromScoring();
      this.getTournamentTeamsFromScoring();
      this.checkdate();
      this.checkTime();
      this.getGamePark();

    },
    initializeDate() {
  // Ensure the date is valid and set it to the date picker
      if (this.singleGame?.start_date) {
        this.startDate = this.parseAndFormatDate(this.singleGame?.start_date);
      }
    },
    parseAndFormatDate(dateString) {
      if (!dateString) return "";
      
      // For ISO format dates (YYYY-MM-DD), parse components directly
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        const [year, month, day] = dateString.split('-').map(Number);
        // Create date using local time components (months are 0-indexed in JS)
        return this.formatDate(new Date(year, month - 1, day));
      }
      
      // For other date formats
      const cleanDateString = dateString.replace(/\sGMT.*$/, "");
      let parsedDate = new Date(cleanDateString);
      
      if (isNaN(parsedDate.getTime())) {
        try {
          parsedDate = new Date(Date.parse(dateString));
        } catch (e) {
          return "Invalid Date";
        }
      }
      
      return this.formatDate(parsedDate);
    },
    formatDate(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return "Invalid Date";
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const month = monthNames[date.getMonth()];
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      return `${month} ${day}, ${year}`;
    },

    formatDateForDB(date) {
      if (!date) return null; // Ensure there's a valid date
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
  },
  mounted() {
    this.$root.$on("openTournamentEditGameModal1", (data) => {
      this.singleGame = data;
      this.startDateError = "";
      this.checkUpdate();
      var elem = this.$refs.openModalTournamentEditGame;
      if (elem) {
        elem.click();
        this.getTournamentName();
      }
    });
    this.$root.$on("openTournamentEditGameModal2", (data) => {
      this.singleGame = data;
      this.startDateError = "";
      this.checkUpdate1();
      var elem = this.$refs.openModalTournamentEditGame;
      if (elem) {
        elem.click();
        this.getTournamentName();
      }
    });
    this.$root.$on("addedPark", (Tabs) => {
      this.tabsTo = Tabs;
      this.getGamePark();
      var elem = this.$refs.openModalTournamentEditGame;
      elem.click();
    });
    this.$root.$on("editedGameField", (Tabs) => {
      this.tabsTo = Tabs;
      this.parkField = "";
      this.getParkField();
      var elem = this.$refs.openModalTournamentEditGame;
      elem.click();
    });
    this.$root.$on("checkMain", () => {
      this.closeMain();
    });
  },
};
</script>